import useDentalDataContext from 'src/packages/dental/hooks/useDentalContext';
import React from 'react';
import { Alert, Col, Container, Icon, Row, Spinner } from '@digitools/honest-react';
import PlanDeductibles from 'src/packages/dental/components/PlanDeductibles';
import Coinsurances from 'src/packages/dental/components/Coinsurances';
import PlanMaximums from 'src/packages/dental/components/PlanMaximums';
import useMediaQuery from 'src/hooks/useMediaQuery';
import { DentalSubHeading, DentalTabPanel, ErrorHtml, TabsDisclaimerText } from 'src/packages/dental/Dental';
import DOMPurify from 'dompurify';
const DeductiblesTabPanelContents = () => {
    const isTitleView = useMediaQuery('(max-width: 780px)');
    return <Container className={'w-100 p-0 m-0'} fluid={true}>
      {isTitleView ? (<>
          <Row>
            <Col>
              <PlanDeductibles />
            </Col>
          </Row>
          <Row>
            <Col>
              <PlanMaximums />
            </Col>
          </Row>
        </>) : (<Row>
          <Col>
            <PlanDeductibles />
          </Col>
          <Col>
            <PlanMaximums />
          </Col>
        </Row>)}
      <Row>
        <Col>
          <Coinsurances />
        </Col>
      </Row>
    </Container>;
};
export const DeductibleAndCoinsuranceInfo = () => {
    const isTitleView = useMediaQuery('(max-width: 780px)');
    const { currentMember, deductiblesLoading } = useDentalDataContext();
    const data = currentMember?.deductiblesAndCoinsurance;
    const hasCoinsurance = !!data?.coinsurances?.length;
    const hasPlanMaximum = !!data?.planMaximums?.length;
    const hasPlanDeductibles = !!data?.planDeductibles?.length;
    const hasData = hasCoinsurance || hasPlanMaximum || hasPlanDeductibles;
    if (deductiblesLoading) {
        return <Spinner data-testid='deductibles-spinner'/>;
    }
    return (<div data-public={true}>
      {hasData ? (isTitleView ? (<DentalTabPanel>
            <DeductiblesTabPanelContents />
          </DentalTabPanel>) : (<DeductiblesTabPanelContents />)) : (<>
          {!deductiblesLoading &&
                (currentMember?.deductiblesAndCoinsurance || currentMember?.deductiblesError) &&
                (isTitleView ? (<DentalTabPanel>
                <ErrorHtml errorType={currentMember?.deductiblesError}/>
              </DentalTabPanel>) : (<ErrorHtml errorType={currentMember?.deductiblesError}/>))}
        </>)}
    </div>);
};
export const DeductiblesAndCoinsuranceHeader = ({ title, text }) => {
    const isTitleView = useMediaQuery('(max-width: 780px)');
    return (<div>
      <div style={{ paddingLeft: '0.625em', paddingRight: '0.625em' }}>
        <DentalSubHeading text={title} isTitleView={isTitleView}/>
      </div>
      <Row style={{ paddingBottom: '2rem' }}>
        <Col className={'ml-2 font-weight-light'}>
          <Icon className={'align-middle'} size='small' name='info' color={'secondary'} title={'deductibles info'}/>
          {text && <p style={{ fontSize: '0.875rem' }} className={'font-weight-light pr-3 pl-2 d-inline'} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }}/>}
        </Col>
      </Row>
    </div>);
};
const DeductibleAndCoinsurance = () => {
    const { currentMember, subscriber } = useDentalDataContext();
    return (<>
      {!!currentMember && !!subscriber && (<>
          <TabsDisclaimerText />
          {subscriber?.planOverview?.inNetworkOnlyClause && (<Row className={'pt-0 mt-0'}>
              <Col>
                <Alert className={'mb-3'} style={{ padding: '.5rem' }} type={'info'}>
                  {subscriber.planOverview.inNetworkOnlyClause}
                </Alert>
              </Col>
            </Row>)}
          <DeductibleAndCoinsuranceInfo />
        </>)}
    </>);
};
export const dentalBoxClass = (isTitleView) => isTitleView ? 'pl-0 pr-0 pb-0' : 'pb-0 h-100';
export const dentalTableClass = (isTitleView) => isTitleView ? 'p-0 mt-0 mb-1 mr-0' : 'pt-0 mt-0 mb-1';
export default DeductibleAndCoinsurance;
